<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_friendsLink" :custom="{storage:true}" export :refresh="{query: findList}">
      <template v-slot:buttons>
        <el-button @click="listQuery.pageNum=1;findList()">查询</el-button>
        <el-button @click="funcAdd">新增</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      highlight-hover-row
      row-id="id_friendsLink"
      class="mytable-footer"
      height="80%"
      show-overflow
      show-footer
      :footer-method="footerMethod"
      :footer-cell-class-name="footerCellClassName"
      :data="tableData"
      sort-config.remote
      export-config
      @sort-change="sortList"
    >
          
      <vxe-table-column>
        <vxe-table-column field="linkName" title="名称" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.linkName" placeholder="请输入名称" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="linkUrl" title="链接地址" min-width="100" sortable />
             
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="funcDetail(scope.row.code)">
              <em class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <em class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <em class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal v-model="modelEditFlag" :title="title" width="500" height="300" resize>
      <compEdit ref="editRef" @fatherEditMethod="fatherEdit" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>

  </div>
</template>
<script>
    import compEdit from './components/friendsLinkEdit.vue'
    import request from '@/utils/request'
    export default {
        name: 'FriendsLinkList',
        components: {
            compEdit
        },
        data() {
            return {
                title: '编辑',
                message: '',
                loading: false,
                tableData: [],
                modelEditFlag: false,
                copy: false,
                Pagingconf: [20, 30, 50, 100],
                listQuery: {
                    code: '',
                    userCode: '',
                    branchCode: '',
                    linkName: '',
                    linkUrl: '',
                    pageNum: 1,
                    pageSize: 20,
                    sortField: '',
                    sortType: '',
                    total: 0
                }
            }
        },
        created() {
            this.findList()
        },
        methods: {
            findList() {
                this.loading = true
                return request({
                    url: '/ntocc-basic-api/friendsLink',
                    method: 'get',
                    params: this.listQuery
                }).then(response => {
                    this.tableData = response.data.records
                    let total = response.data.total
                    this.listQuery.total = total
                    // this.Pagingconf =　total &&　total > 100　? [20, 30, 50, 100, total] : [20, 30, 50, 100];
                    this.loading = false
                })
            },
            // 排序
            sortList({ column, property, order }) {
                if (order) {
                    this.listQuery.sortField = property
                    this.listQuery.sortType = order
                } else {
                    this.listQuery.sortField = ''
                }
                this.findList()
            },
            // 添加方法
            funcAdd() {
                this.title = '新增'
                this.$refs.editRef.init(false)
                this.modelEditFlag = true
            },
            // 修改方法
            funcEdit(code) {
                this.title = '修改'
                this.$refs.editRef.init(false)
                this.$refs.editRef.getInfo(code)
                this.modelEditFlag = true
            },
            // 详情方法
            funcDetail(code) {
                this.title = '详情'
                this.$refs.editRef.init(true)
                this.$refs.editRef.getInfo(code)
                this.modelEditFlag = true
            },
            // 删除方法
            funcDelete(row) {
                this.$confirm('确认删除吗？').then(_ => {
                    request({url: `/ntocc-basic-api/friendsLink`, method: 'delete', params: { codes: row }}).then(response => {
                        this.$message({ message: response.msg, type: 'success' })
                        this.findList()
                    })
                }).catch(_ => {})
            },
            // 增加组件的父方法
            fatherAdd() {
                this.modelAddFlag = false
                this.findList()
            },
            // 编辑组件的父方法
            fatherEdit() {
                this.modelEditFlag = false
                this.findList()
            },
            // 公共取消
            fatherCancel(modelFlag) {
                if (modelFlag == 'edit') {
                    this.modelEditFlag = false
                }
            },
            // 分页handle
            handlePageChange({ currentPage, pageSize }) {
                this.listQuery.pageNum = currentPage
                this.listQuery.pageSize = pageSize
                this.findList()
            },
            // 底部颜色设置
            footerCellClassName({ $rowIndex, column, columnIndex }) {
                if (columnIndex === 0) {
                    if ($rowIndex === 0) {
                        return 'col-blue'
                    } else {
                        return 'col-red'
                    }
                }
            },
            // 设置底部合计
            footerMethod({ columns, data }) {
                return [
                    columns.map((column, columnIndex) => {
                        if (columnIndex === 0) {
                    return '合计'
                }
                if (['pageviews', 'forecast'].includes(column.property)) {
                    return XEUtils.sum(data, column.property)
                }
                return null
            })
            ]
            }
        }
    }
</script>
